// This file is auto-generated by @hey-api/openapi-ts

import * as z from "zod";

export const zUserUpdateDto = z.object({
  displayName: z.string().min(0).max(200).nullish(),
});

export const zUserListDto = z.object({
  id: z.uuid(),
  email: z.string().nullish(),
  displayName: z.string().nullish(),
  status: z.string(),
  emailVerified: z.boolean(),
  createdAt: z.iso.datetime(),
});

export const zUserGroupsDto = z.object({
  groupIds: z.array(z.uuid()),
});

export const zOrderUpdateDto = z.object({
  notes: z.string().nullish(),
  orderedAt: z.iso.datetime().nullish(),
});

export const zMoney = z.object({
  amount: z.number(),
  currency: z.object({
    currencyCode: z.string().optional(),
    displayName: z.string().optional(),
    symbol: z.string().optional(),
    defaultFractionDigits: z
      .int()
      .min(-2147483648, {
        error: "Invalid value: Expected int32 to be >= -2147483648",
      })
      .max(2147483647, {
        error: "Invalid value: Expected int32 to be <= 2147483647",
      })
      .optional(),
    numericCode: z
      .int()
      .min(-2147483648, {
        error: "Invalid value: Expected int32 to be >= -2147483648",
      })
      .max(2147483647, {
        error: "Invalid value: Expected int32 to be <= 2147483647",
      })
      .optional(),
    numericCodeAsString: z.string().optional(),
  }),
});

export const zOrderLineItemDto = z.object({
  id: z.uuid(),
  orderId: z.uuid(),
  productRefType: z.string().nullish(),
  productRefId: z.uuid().nullish(),
  description: z.string(),
  quantity: z.number(),
  unitPrice: z.number(),
  lineTotal: z.number(),
  position: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    })
    .nullish(),
  createdAt: z.iso.datetime(),
});

export const zOrderDetailDto = z.object({
  id: z.uuid(),
  number: z.string(),
  partyId: z.uuid(),
  status: z.string(),
  total: zMoney,
  notes: z.string().nullish(),
  orderedAt: z.iso.datetime(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  lineItems: z.array(zOrderLineItemDto),
});

export const zOrderLineItemUpdateDto = z.object({
  productRefType: z.string().nullish(),
  productRefId: z.uuid().nullish(),
  description: z.string().nullish(),
  quantity: z.number().nullish(),
  unitPrice: z.number().nullish(),
  position: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    })
    .nullish(),
});

export const zNomenclatureTypeRequest = z.object({
  code: z.string(),
  name: z.string(),
  category: z.string(),
  tags: z.array(z.string()),
  data: z.record(z.string(), z.unknown()),
});

export const zNomenclatureColumnDef = z.object({
  key: z.string(),
  label: z.string(),
  type: z.enum(["STRING", "NUMBER", "BOOLEAN", "DATE", "REFERENCE", "ENUM"]),
  sortable: z.boolean(),
});

export const zNomenclatureTypeDto = z.object({
  id: z.uuid(),
  code: z.string(),
  name: z.string(),
  category: z.string(),
  tags: z.array(z.string()),
  data: z.record(z.string(), z.unknown()),
  columns: z.array(zNomenclatureColumnDef),
});

export const zTypedItemRequestMapStringObject = z.object({
  code: z.string(),
  name: z.string(),
  isActive: z.boolean(),
  isDefault: z.boolean(),
  order: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    })
    .nullish(),
  data: z.record(z.string(), z.unknown()),
});

export const zNomenclatureItemDto = z.object({
  id: z.uuid(),
  typeCode: z.string(),
  code: z.string(),
  name: z.string(),
  isActive: z.boolean(),
  isDefault: z.boolean(),
  order: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    })
    .nullish(),
  data: z.record(z.string(), z.unknown()),
});

export const zGroupUpdateDto = z.object({
  name: z.string().min(0).max(255).nullish(),
  description: z.string().min(0).max(2000).nullish(),
});

export const zGroupListDto = z.object({
  id: z.uuid(),
  code: z.string(),
  name: z.string(),
  description: z.string().nullish(),
});

export const zFileRef = z.object({
  id: z.uuid(),
  fileName: z.string(),
  mediaType: z.string(),
  size: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
});

export const zSmsMoMessageResource = z.object({
  phoneNumber: z.string(),
  receiver: z.string(),
  text: z.string(),
  messageId: z.string(),
  time: z.iso.datetime(),
  conversationId: z.string().nullish(),
  dataCoding: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    })
    .nullish(),
  udh: z.string().nullish(),
  userData: z.string().nullish(),
});

export const zDeliveryReportSmsResource = z.object({
  part: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  total: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
});

export const zDeliveryReportStatusResource = z.object({
  code: z.enum([
    "RECEIVED",
    "ACCEPTED",
    "CONCAT_WAIT",
    "DELIVERED",
    "DELETED",
    "ENROUTE",
    "EXPIRED",
    "REJECTED",
    "UNDELIVERABLE",
    "THROTTLING",
    "NO_ROUTE",
    "NONE",
    "ERROR",
    "INSUFFICIENT_FUNDS",
    "USER_BLOCKED",
    "BLACKLISTED",
    "DELIVERY_FAILED",
    "SUBMITTED",
    "SEEN",
    "PENDING",
    "SENT",
    "READ",
    "UNSUPPORTED",
    "FAILED",
    "SOFT_BOUNCED",
    "HARD_BOUNCED",
    "UNKNOWN",
  ]),
  details: z.string().nullish(),
  errorCode: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    })
    .nullish(),
});

export const zDeliveryReportResource = z.object({
  channel: z.enum(["SMS"]),
  messageId: z.uuid(),
  status: zDeliveryReportStatusResource,
  time: z.iso.datetime(),
  transactionId: z.string(),
  sms: zDeliveryReportSmsResource.nullish(),
});

export const zApiMeta = z.object({
  code: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  text: z.string(),
});

export const zMoAckData = z.object({
  text: z.string().nullish(),
});

export const zMoAck = z.object({
  meta: zApiMeta,
  data: zMoAckData.nullish(),
});

export const zMoPushPayload = z.object({
  msisdn: z.string(),
  sc: z.string(),
  text: z.string(),
  service_id: z.string(),
  sms_id: z.string(),
  type: z.enum(["MO"]),
  mno_request_dt: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/)
    .optional(),
  mcc: z.string().nullish(),
  mnc: z.string().nullish(),
});

export const zWebhookAck = z.object({
  meta: zApiMeta,
});

export const zDlrPushPayload = z.object({
  status: z.union([
    z.literal(201),
    z.literal(202),
    z.literal(203),
    z.literal(204),
    z.literal(205),
    z.literal(206),
  ]),
  status_msg: z.string(),
  sent_timestamp: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/),
  dlr_timestamp: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/),
  sms_id: z.string(),
  service_id: z.string(),
  type: z.enum(["DLR"]),
  channel: z.enum(["SMS", "VIBER"]),
});

export const zInboundResult = z.object({
  emailId: z.uuid(),
});

export const zUserCreateDto = z.object({
  email: z.email().min(1),
  displayName: z.string().min(0).max(200),
});

export const zAdminPasswordResetResultDto = z.object({
  token: z.string(),
  expiresAt: z.iso.datetime(),
});

export const zTemplateValidationDto = z.object({
  isValid: z.boolean(),
  validated: z.boolean(),
  unknownPlaceholders: z.array(z.string()),
  unusedFields: z.array(z.string()),
  resolvedFields: z.array(z.string()),
});

export const zJsonNode = z.object({
  array: z.boolean().optional(),
  empty: z.boolean().optional(),
  null: z.boolean().optional(),
  float: z.boolean().optional(),
  number: z.boolean().optional(),
  boolean: z.boolean().optional(),
  double: z.boolean().optional(),
  short: z.boolean().optional(),
  string: z.boolean().optional(),
  valueNode: z.boolean().optional(),
  container: z.boolean().optional(),
  missingNode: z.boolean().optional(),
  object: z.boolean().optional(),
  nodeType: z
    .enum([
      "ARRAY",
      "BINARY",
      "BOOLEAN",
      "MISSING",
      "NULL",
      "NUMBER",
      "OBJECT",
      "POJO",
      "STRING",
    ])
    .optional(),
  bigDecimal: z.boolean().optional(),
  bigInteger: z.boolean().optional(),
  textual: z.boolean().optional(),
  binary: z.boolean().optional(),
  int: z.boolean().optional(),
  long: z.boolean().optional(),
  pojo: z.boolean().optional(),
  integralNumber: z.boolean().optional(),
  floatingPointNumber: z.boolean().optional(),
  embeddedValue: z.boolean().optional(),
});

export const zPreviewRequest = z.object({
  context: zJsonNode,
  language: z.string().nullish(),
});

export const zProviderCallbackDto = z.object({
  params: z.record(z.string(), z.string()),
  body: z.string().nullish(),
});

export const zPaymentOrderCreateDto = z.object({
  partyId: z.uuid().nullish(),
  amount: z.number().nullish(),
  currency: z.string().nullish(),
  method: z.string().nullish(),
  provider: z.string().nullish(),
  targetType: z.string(),
  targetId: z.uuid().nullish(),
});

export const zPaymentMethodRef = z.object({
  method: z.string(),
  provider: z.string(),
});

export const zPaymentOrder = z.object({
  id: z.uuid(),
  number: z.string(),
  partyId: z.uuid(),
  amount: zMoney,
  method: z.string(),
  provider: z.string(),
  status: z.string(),
  targetType: z.string(),
  targetId: z.uuid(),
  methodRef: zPaymentMethodRef,
});

export const zIntentRequestDto = z.object({
  returnUrl: z.string().nullish(),
  params: z.record(z.string(), z.string()),
});

export const zPaymentIntent = z.object({
  expiresAt: z.iso.datetime(),
  type: z.string(),
});

export const zClientSecret = zPaymentIntent.and(
  z.object({
    provider: z.string(),
    secret: z.string(),
    publishableKey: z.string(),
    sdkConfig: z.record(z.string(), z.unknown()),
    type: z.literal("ClientSecret"),
  }),
);

export const zGatewayFormPost = zPaymentIntent.and(
  z.object({
    url: z.string(),
    method: z.string(),
    fields: z.record(z.string(), z.string()),
    bridgeUrl: z.string().nullish(),
    intentToken: z.string().nullish(),
    type: z.literal("GatewayFormPost"),
  }),
);

export const zHostedSession = zPaymentIntent.and(
  z.object({
    provider: z.string(),
    sessionId: z.string(),
    redirectUrl: z.string().nullish(),
    sdkConfig: z.record(z.string(), z.unknown()),
    type: z.literal("HostedSession"),
  }),
);

export const zNoOp = zPaymentIntent.and(
  z.object({
    type: z.literal("NoOp"),
  }),
);

export const zOrderLineItemInput = z.object({
  productRefType: z.string().nullish(),
  productRefId: z.uuid().nullish(),
  description: z.string().nullish(),
  quantity: z.number().nullish(),
  unitPrice: z.number().nullish(),
  position: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    })
    .nullish(),
});

export const zOrderCreateDto = z.object({
  partyId: z.uuid().nullish(),
  currency: z.string().nullish(),
  notes: z.string().nullish(),
  orderedAt: z.iso.datetime().nullish(),
  lineItems: z.array(zOrderLineItemInput),
});

export const zCancelRequest = z.object({
  reason: z.string().nullish(),
});

export const zMassActionRequest = z.object({
  ids: z.array(z.uuid()),
  reason: z.string().nullish(),
});

export const zMassActionError = z.object({
  id: z.uuid(),
  code: z.string().nullish(),
  message: z.string().nullish(),
});

export const zMassActionResultDto = z.object({
  succeeded: z.array(z.uuid()),
  failed: z.array(zMassActionError),
});

export const zMarkReadRequest = z.object({
  ids: z.array(z.uuid()),
});

export const zMarkReadResponse = z.object({
  updated: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
});

export const zImportResultDto = z.object({
  imported: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  warnings: z.array(z.string()),
});

export const zDispatchResponse = z.object({
  originalId: z.uuid().nullish(),
  newId: z.uuid(),
});

export const zManualDispatchRequest = z.object({
  jobType: z.string().min(1),
  params: zJsonNode.nullish(),
});

export const zGroupCreateDto = z.object({
  code: z
    .string()
    .min(0)
    .max(100)
    .regex(/[A-Z][A-Z0-9_]*/),
  name: z.string().min(0).max(255),
  description: z.string().min(0).max(2000).nullish(),
});

export const zFileListDto = z.object({
  id: z.uuid(),
  fileName: z.string(),
  mediaType: z.string(),
  sizeBytes: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
  createdAt: z.iso.datetime(),
});

export const zLinkRequest = z.object({
  objectType: z.string(),
  objectId: z.uuid(),
  path: z.string(),
});

export const zUploadUrlRequest = z.object({
  fileName: z.string(),
  mediaType: z.string(),
});

export const zPresignedUrl = z.object({
  url: z.url(),
  expiresAt: z.iso.datetime(),
});

export const zEmailLinkRequest = z.object({
  objectType: z.string(),
  objectId: z.uuid(),
});

export const zEmailSendAttachmentRequest = z.object({
  fileId: z.uuid(),
  fileName: z.string(),
  mediaType: z.string(),
  sizeBytes: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
  inline: z.boolean(),
  contentId: z.string().nullish(),
});

export const zEmailSendRequest = z.object({
  from: z.string().nullish(),
  to: z.array(z.string()),
  cc: z.array(z.string()),
  bcc: z.array(z.string()),
  subject: z.string(),
  bodyHtml: z.string().nullish(),
  bodyText: z.string().nullish(),
  replyTo: z.string().nullish(),
  headers: z.record(z.string(), z.string()),
  attachments: z.array(zEmailSendAttachmentRequest),
});

export const zEmailAttachmentDto = z.object({
  partIndex: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  fileName: z.string().nullish(),
  mediaType: z.string(),
  sizeBytes: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
  contentId: z.string().nullish(),
  isInline: z.boolean(),
});

export const zEmailObjectLinkDto = z.object({
  objectType: z.string(),
  objectId: z.uuid(),
});

export const zEmailStatusEventDto = z.object({
  status: z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "OPENED",
    "CLICKED",
    "BOUNCED",
    "COMPLAINED",
    "FAILED",
  ]),
  metadata: z.string(),
  createdAt: z.iso.datetime(),
});

export const zEmailDetailDto = z.object({
  id: z.uuid(),
  direction: z.string(),
  fromAddress: z.string(),
  toAddresses: z.array(z.string()),
  ccAddresses: z.array(z.string()),
  bccAddresses: z.array(z.string()),
  subject: z.string().nullish(),
  replyTo: z.string().nullish(),
  externalId: z.string().nullish(),
  deliveryStatus: z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "OPENED",
    "CLICKED",
    "BOUNCED",
    "COMPLAINED",
    "FAILED",
  ]),
  notificationId: z.uuid().nullish(),
  rawEmlRef: z.uuid(),
  createdAt: z.iso.datetime(),
  statusEvents: z.array(zEmailStatusEventDto),
  attachments: z.array(zEmailAttachmentDto),
  linkedObjects: z.array(zEmailObjectLinkDto),
});

export const zCheckoutScenarioRequest = z.object({
  amount: z.string().nullish(),
  currency: z.string().nullish(),
  cardholderName: z.string(),
  email: z.string(),
  address: z.string(),
  description: z.string(),
});

export const zCheckoutScenarioResponse = z.object({
  partyId: z.uuid(),
  orderId: z.uuid(),
  paymentOrderId: z.uuid(),
  checkoutPath: z.string(),
});

export const zViberSendRequest = z.object({
  msisdn: z.string(),
  text: z.string(),
  buttonName: z.string().nullish(),
  buttonUrl: z.string().nullish(),
});

export const zSendResponse = z.object({
  mobileMessageId: z.uuid(),
  status: z.string(),
});

export const zUserSignedUpRequest = z.object({
  userId: z.uuid(),
  email: z.string(),
  generatedPassword: z.string(),
});

export const zTriggerResponse = z.object({
  message: z.string(),
});

export const zSmsSendRequest = z.object({
  msisdn: z.string(),
  text: z.string(),
});

export const zReportPublishedRequest = z.object({
  ownerUserId: z.uuid(),
  reportId: z.uuid(),
  year: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  name: z.string(),
});

export const zRefreshBody = z.object({
  refreshToken: z.string().nullish(),
});

export const zRefreshResponse = z.object({
  accessToken: z.string(),
  refreshToken: z.string().nullish(),
  expiresAt: z.string(),
  sessionType: z.string(),
});

export const zDeviceInfo = z.object({
  userAgent: z.string().nullish(),
  platform: z.string().nullish(),
  appVersion: z.string().nullish(),
});

export const zLoginRequest = z.object({
  email: z.email().min(1),
  password: z.string().min(0).max(256),
  tenantId: z.uuid().nullish(),
  sessionType: z
    .string()
    .regex(/web|mobile/)
    .nullish(),
  deviceInfo: zDeviceInfo.nullish(),
});

export const zLoginResponse = z.object({
  userId: z.uuid(),
  accessToken: z.string(),
  refreshToken: z.string().nullish(),
  expiresAt: z.string(),
  sessionType: z.string(),
});

export const zPaginationMeta = z.object({
  page: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  pageSize: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  totalItems: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
  totalPages: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
});

export const zPageResponseUserListDto = z.object({
  data: z.array(zUserListDto),
  pagination: zPaginationMeta,
});

export const zTemplateSummaryDto = z.object({
  code: z.string(),
  format: z.string(),
  description: z.string(),
  contextType: z.string(),
  regenerable: z.boolean(),
});

export const zPartInfoDto = z.object({
  format: z.string(),
  subPath: z.string(),
  hasDefaultVariant: z.boolean(),
  languages: z.array(z.string()),
});

export const zTemplateDetailDto = z.object({
  code: z.string(),
  format: z.string(),
  description: z.string(),
  contextType: z.string(),
  contextProperties: z.array(z.string()),
  regenerable: z.boolean(),
  hasDefaultVariant: z.boolean(),
  languages: z.array(z.string()),
  resourcePath: z.string(),
  parts: z.record(z.string(), zPartInfoDto),
});

export const zPaymentOrderListDto = z.object({
  id: z.uuid(),
  number: z.string(),
  partyId: z.uuid(),
  status: z.string(),
  method: z.string(),
  provider: z.string(),
  amountAmount: z.number(),
  amountCurrency: z.string(),
  targetType: z.string(),
  targetId: z.uuid(),
  createdAt: z.iso.datetime(),
});

export const zPageResponsePaymentOrderListDto = z.object({
  data: z.array(zPaymentOrderListDto),
  pagination: zPaginationMeta,
});

export const zOrderListDto = z.object({
  id: z.uuid(),
  number: z.string(),
  partyId: z.uuid(),
  status: z.string(),
  currency: z.string(),
  totalAmount: z.number(),
  orderedAt: z.iso.datetime(),
  createdAt: z.iso.datetime(),
});

export const zPageResponseOrderListDto = z.object({
  data: z.array(zOrderListDto),
  pagination: zPaginationMeta,
});

export const zPageResponseOrderLineItemDto = z.object({
  data: z.array(zOrderLineItemDto),
  pagination: zPaginationMeta,
});

export const zNotificationListDto = z.object({
  id: z.uuid(),
  typeCode: z.string(),
  subject: z.string().nullish(),
  body: z.string().nullish(),
  isRead: z.boolean(),
  createdAt: z.iso.datetime(),
});

export const zPageResponseNotificationListDto = z.object({
  data: z.array(zNotificationListDto),
  pagination: zPaginationMeta,
});

export const zNotificationDeliveryEventDto = z.object({
  status: z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "READ",
    "OPENED",
    "BOUNCED",
    "FAILED",
    "EXPIRED",
  ]),
  createdAt: z.iso.datetime(),
  metadata: z.string(),
});

export const zNotificationDeliveryDto = z.object({
  id: z.uuid(),
  channel: z.enum([
    "IN_PLATFORM",
    "WEBSOCKET",
    "EMAIL",
    "SMS",
    "VIBER",
    "PUSH",
  ]),
  status: z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "READ",
    "OPENED",
    "BOUNCED",
    "FAILED",
    "EXPIRED",
  ]),
  subject: z.string().nullish(),
  body: z.string().nullish(),
  externalId: z.string().nullish(),
  createdAt: z.iso.datetime(),
  events: z.array(zNotificationDeliveryEventDto),
});

export const zNotificationDetailDto = z.object({
  id: z.uuid(),
  typeCode: z.string(),
  context: z.string(),
  createdAt: z.iso.datetime(),
  deliveries: z.array(zNotificationDeliveryDto),
});

export const zUnreadCountResponse = z.object({
  unread: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
});

export const zNotificationTypeDto = z.object({
  code: z.string(),
  description: z.string(),
  signalClass: z.string(),
  defaultChannels: z.array(
    z.enum(["IN_PLATFORM", "WEBSOCKET", "EMAIL", "SMS", "VIBER", "PUSH"]),
  ),
  templatedChannels: z.array(
    z.enum(["IN_PLATFORM", "WEBSOCKET", "EMAIL", "SMS", "VIBER", "PUSH"]),
  ),
  deduplicated: z.boolean(),
});

export const zPageResponseNomenclatureTypeDto = z.object({
  data: z.array(zNomenclatureTypeDto),
  pagination: zPaginationMeta,
});

export const zPageResponseNomenclatureItemDto = z.object({
  data: z.array(zNomenclatureItemDto),
  pagination: zPaginationMeta,
});

export const zMobileMessageListDto = z.object({
  id: z.uuid(),
  direction: z.enum(["OUTBOUND", "INBOUND"]),
  channel: z.enum([
    "IN_PLATFORM",
    "WEBSOCKET",
    "EMAIL",
    "SMS",
    "VIBER",
    "PUSH",
  ]),
  provider: z.string(),
  address: z.string(),
  deliveryStatus: z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "READ",
    "OPENED",
    "BOUNCED",
    "FAILED",
    "EXPIRED",
  ]),
  notificationId: z.uuid().nullish(),
  externalId: z.string().nullish(),
  createdAt: z.iso.datetime(),
});

export const zPageResponseMobileMessageListDto = z.object({
  data: z.array(zMobileMessageListDto),
  pagination: zPaginationMeta,
});

export const zMobileMessageStatusEventDto = z.object({
  status: z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "READ",
    "OPENED",
    "BOUNCED",
    "FAILED",
    "EXPIRED",
  ]),
  errorCode: z.string().nullish(),
  metadata: z.string(),
  observedAt: z.iso.datetime(),
  createdAt: z.iso.datetime(),
});

export const zMobileMessageDetailDto = z.object({
  id: z.uuid(),
  direction: z.enum(["OUTBOUND", "INBOUND"]),
  channel: z.enum([
    "IN_PLATFORM",
    "WEBSOCKET",
    "EMAIL",
    "SMS",
    "VIBER",
    "PUSH",
  ]),
  provider: z.string(),
  address: z.string(),
  body: z.string().nullish(),
  options: z.string().nullish(),
  externalId: z.string().nullish(),
  deliveryStatus: z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "READ",
    "OPENED",
    "BOUNCED",
    "FAILED",
    "EXPIRED",
  ]),
  errorCode: z.string().nullish(),
  notificationId: z.uuid().nullish(),
  inReplyToId: z.uuid().nullish(),
  createdAt: z.iso.datetime(),
  sentAt: z.iso.datetime().nullish(),
  deliveredAt: z.iso.datetime().nullish(),
  failedAt: z.iso.datetime().nullish(),
  statusEvents: z.array(zMobileMessageStatusEventDto),
});

export const zScheduledJobDto = z.object({
  identity: z.string(),
  jobType: z.string().nullish(),
  state: z.string(),
  cronExpression: z.string().nullish(),
  nextFireAt: z.iso.datetime().nullish(),
  previousFireAt: z.iso.datetime().nullish(),
  payloadBase64: z.string().nullish(),
});

export const zJobExecutionDto = z.object({
  id: z.uuid(),
  tenantId: z.uuid().nullish(),
  jobType: z.string(),
  queue: z.string(),
  status: z.string(),
  attempt: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  maxAttempts: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  payloadBase64: z.string(),
  payloadSize: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  lastError: z.string().nullish(),
  createdAt: z.iso.datetime(),
  startedAt: z.iso.datetime().nullish(),
  completedAt: z.iso.datetime().nullish(),
  createdBy: z.uuid().nullish(),
});

export const zPageResponseJobExecutionDto = z.object({
  data: z.array(zJobExecutionDto),
  pagination: zPaginationMeta,
});

export const zJobDefinitionDto = z.object({
  jobType: z.string(),
  queue: z.string(),
  paramsClass: z.string(),
  maxAttempts: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  initialDelayMs: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
  multiplier: z.number(),
});

export const zPageResponseGroupListDto = z.object({
  data: z.array(zGroupListDto),
  pagination: zPaginationMeta,
});

export const zPageResponseFileListDto = z.object({
  data: z.array(zFileListDto),
  pagination: zPaginationMeta,
});

export const zEmailListDto = z.object({
  id: z.uuid(),
  direction: z.string(),
  fromAddress: z.string(),
  toAddresses: z.array(z.string()),
  subject: z.string().nullish(),
  deliveryStatus: z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "OPENED",
    "CLICKED",
    "BOUNCED",
    "COMPLAINED",
    "FAILED",
  ]),
  createdAt: z.iso.datetime(),
});

export const zPageResponseEmailListDto = z.object({
  data: z.array(zEmailListDto),
  pagination: zPaginationMeta,
});

export const zUserRef = z.uuid();

export const zLabeledUserRef = z.object({
  value: zUserRef,
  label: z.string(),
});

export const zAuditEntryDto = z.object({
  id: z.uuid(),
  createdAt: z.iso.datetime(),
  actorId: zLabeledUserRef.nullish(),
  objectType: z.string(),
  objectId: z.uuid(),
  action: z.string(),
  changes: z.string().nullish(),
});

export const zPageResponseAuditEntryDto = z.object({
  data: z.array(zAuditEntryDto),
  pagination: zPaginationMeta,
});

export const zAuditObjectConfig = z.object({
  objectType: z.string(),
  auditCreate: z.boolean(),
  auditUpdate: z.boolean(),
  auditDelete: z.boolean(),
  fields: z.array(z.string()),
  excludeFields: z.array(z.string()),
  accessLogged: z.boolean(),
  notifyOn: z.array(z.string()),
  retentionDays: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    })
    .nullish(),
  accessRetentionDays: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    })
    .nullish(),
});

export const zAccessLogDto = z.object({
  id: z.uuid(),
  createdAt: z.iso.datetime(),
  actorId: zLabeledUserRef.nullish(),
  objectType: z.string(),
  objectId: z.uuid().nullish(),
  action: z.string(),
});

export const zPageResponseAccessLogDto = z.object({
  data: z.array(zAccessLogDto),
  pagination: zPaginationMeta,
});

export const zFieldError = z.object({
  field: z.string().nullish(),
  message: z.string(),
  code: z.string().nullish(),
});

export const zProblemDetailResponse = z.object({
  type: z.string(),
  title: z.string(),
  status: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
  detail: z.string().nullish(),
  instance: z.string().nullish(),
  errors: z.array(zFieldError).nullish(),
  traceId: z.string().nullish(),
  stackTrace: z.string().nullish(),
  diagnostics: z.record(z.string(), z.unknown()).nullish(),
});

export const zUserDeletePath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zUserDeleteResponse = z.void();

export const zUserDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zUserDetailResponse = zUserListDto;

export const zUserUpdateBody = zUserUpdateDto;

export const zUserUpdatePath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zUserUpdateResponse = zUserListDto;

export const zUserGroupsPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zUserGroupsResponse = z.array(zGroupListDto);

export const zUserSetGroupsBody = zUserGroupsDto;

export const zUserSetGroupsPath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zUserSetGroupsResponse = z.void();

export const zOrderDeletePath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zOrderDeleteResponse = z.void();

export const zOrderDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zOrderDetailResponse = zOrderDetailDto;

export const zOrderUpdateBody = zOrderUpdateDto;

export const zOrderUpdatePath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zOrderUpdateResponse = zOrderDetailDto;

export const zOrderRemoveLineItemPath = z.object({
  id: z.uuid(),
  itemId: z.uuid(),
});

/**
 * No Content
 */
export const zOrderRemoveLineItemResponse = z.void();

export const zOrderGetLineItemPath = z.object({
  id: z.uuid(),
  itemId: z.uuid(),
});

/**
 * OK
 */
export const zOrderGetLineItemResponse = zOrderLineItemDto;

export const zOrderUpdateLineItemBody = zOrderLineItemUpdateDto;

export const zOrderUpdateLineItemPath = z.object({
  id: z.uuid(),
  itemId: z.uuid(),
});

/**
 * OK
 */
export const zOrderUpdateLineItemResponse = zOrderLineItemDto;

export const zNomenclatureTypeDeletePath = z.object({
  typeCode: z.string(),
});

/**
 * No Content
 */
export const zNomenclatureTypeDeleteResponse = z.void();

export const zNomenclatureTypeDetailPath = z.object({
  typeCode: z.string(),
});

/**
 * OK
 */
export const zNomenclatureTypeDetailResponse = zNomenclatureTypeDto;

export const zNomenclatureTypeUpdateBody = zNomenclatureTypeRequest;

export const zNomenclatureTypeUpdatePath = z.object({
  typeCode: z.string(),
});

/**
 * OK
 */
export const zNomenclatureTypeUpdateResponse = zNomenclatureTypeDto;

export const zNomenclatureDeleteItemPath = z.object({
  typeCode: z.string(),
  id: z.uuid(),
});

/**
 * No Content
 */
export const zNomenclatureDeleteItemResponse = z.void();

export const zNomenclatureGetItemPath = z.object({
  typeCode: z.string(),
  id: z.uuid(),
});

/**
 * OK
 */
export const zNomenclatureGetItemResponse = zNomenclatureItemDto;

export const zNomenclatureUpdateItemBody = zTypedItemRequestMapStringObject;

export const zNomenclatureUpdateItemPath = z.object({
  typeCode: z.string(),
  id: z.uuid(),
});

/**
 * OK
 */
export const zNomenclatureUpdateItemResponse = zNomenclatureItemDto;

export const zGroupDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zGroupDetailResponse = zGroupListDto;

export const zGroupUpdateBody = zGroupUpdateDto;

export const zGroupUpdatePath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zGroupUpdateResponse = zGroupListDto;

export const zFileSignedUploadQuery = z.object({
  path: z.string(),
  type: z.string(),
  expires: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
  sig: z.string(),
});

/**
 * Created
 */
export const zFileSignedUploadResponse = zFileRef;

export const zMessagingWebhooksApiReceiveMoPushBody = zSmsMoMessageResource;

export const zMessagingWebhooksApiReceiveDlrPushBody = zDeliveryReportResource;

export const zMessagingWebhooksApiReceiveMoPush1Body = zMoPushPayload;

/**
 * Acknowledgement, optionally with a synchronous reply.
 */
export const zMessagingWebhooksApiReceiveMoPush1Response = zMoAck;

export const zMessagingWebhooksApiReceiveDlrPush1Body = zDlrPushPayload;

/**
 * Acknowledgement. Anything other than `meta.code: 200` triggers a retry.
 */
export const zMessagingWebhooksApiReceiveDlrPush1Response = zWebhookAck;

export const zBoricaCallbackReceiveQuery = z.object({
  params: z.record(z.string(), z.string()),
});

export const zSendGridInboundWebhookHandleBody = z.object({
  email: z.string().optional(),
});

export const zSendGridInboundWebhookHandleQuery = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  cc: z.string().optional(),
  subject: z.string().optional(),
  text: z.string().optional(),
  html: z.string().optional(),
  headers: z.string().optional(),
  attachments: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    })
    .optional()
    .default(0),
});

/**
 * OK
 */
export const zSendGridInboundWebhookHandleResponse = zInboundResult;

export const zSendGridStatusWebhookHandleBody = z.string();

export const zSendGridStatusWebhookHandleHeaders = z.object({
  "X-Twilio-Email-Event-Webhook-Signature": z.string().optional(),
  "X-Twilio-Email-Event-Webhook-Timestamp": z.string().optional(),
});

export const zUserListQuery = z.object({
  search: z.string().optional(),
  status: z.string().optional(),
  groupId: z.uuid().optional(),
  providerType: z.string().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "createdAt,asc",
        "createdAt,desc",
        "displayName,asc",
        "displayName,desc",
        "emailVerified,asc",
        "emailVerified,desc",
        "id,asc",
        "id,desc",
        "status,asc",
        "status,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zUserListResponse = zPageResponseUserListDto;

export const zUserCreateBody = zUserCreateDto;

/**
 * Created
 */
export const zUserCreateResponse = zUserListDto;

export const zUserResetPasswordPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zUserResetPasswordResponse = zAdminPasswordResetResultDto;

export const zUserDeactivatePath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zUserDeactivateResponse = z.void();

export const zUserActivatePath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zUserActivateResponse = z.void();

export const zTemplateValidateBody = z.object({
  file: z.string(),
});

export const zTemplateValidatePath = z.object({
  code: z.string(),
});

export const zTemplateValidateQuery = z.object({
  language: z.string().optional(),
  part: z.string().optional(),
});

/**
 * OK
 */
export const zTemplateValidateResponse = zTemplateValidationDto;

export const zTemplatePreviewBody = zPreviewRequest;

export const zTemplatePreviewPath = z.object({
  code: z.string(),
});

export const zTemplatePreviewQuery = z.object({
  part: z.string().optional(),
});

/**
 * OK
 */
export const zTemplatePreviewResponse = z.string();

export const zPaymentProviderCallbackCallbackBody = zProviderCallbackDto;

export const zPaymentProviderCallbackCallbackPath = z.object({
  provider: z.string(),
});

export const zPaymentOrderListQuery = z.object({
  status: z.string().optional(),
  partyId: z.uuid().optional(),
  method: z.string().optional(),
  provider: z.string().optional(),
  targetId: z.uuid().optional(),
  amountFrom: z.number().optional(),
  amountTo: z.number().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "amountAmount,asc",
        "amountAmount,desc",
        "amountCurrency,asc",
        "amountCurrency,desc",
        "createdAt,asc",
        "createdAt,desc",
        "id,asc",
        "id,desc",
        "method,asc",
        "method,desc",
        "number,asc",
        "number,desc",
        "partyId,asc",
        "partyId,desc",
        "provider,asc",
        "provider,desc",
        "status,asc",
        "status,desc",
        "targetId,asc",
        "targetId,desc",
        "targetType,asc",
        "targetType,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zPaymentOrderListResponse = zPageResponsePaymentOrderListDto;

export const zPaymentOrderCreateBody = zPaymentOrderCreateDto;

/**
 * Created
 */
export const zPaymentOrderCreateResponse = zPaymentOrder;

export const zPaymentOrderSubmitPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zPaymentOrderSubmitResponse = zPaymentOrder;

export const zPaymentOrderIntentBody = zIntentRequestDto;

export const zPaymentOrderIntentPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zPaymentOrderIntentResponse = z.union([
  zClientSecret,
  zGatewayFormPost,
  zHostedSession,
  zNoOp,
]);

export const zOrderListQuery = z.object({
  status: z
    .enum([
      "DRAFT",
      "SUBMITTED",
      "CONFIRMED",
      "IN_PROGRESS",
      "FULFILLED",
      "CLOSED",
      "CANCELLED",
      "REJECTED",
    ])
    .optional(),
  partyId: z.uuid().optional(),
  totalFrom: z.number().optional(),
  totalTo: z.number().optional(),
  dateFrom: z.iso.datetime().optional(),
  dateTo: z.iso.datetime().optional(),
  numberContains: z.string().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "createdAt,asc",
        "createdAt,desc",
        "currency,asc",
        "currency,desc",
        "id,asc",
        "id,desc",
        "number,asc",
        "number,desc",
        "orderedAt,asc",
        "orderedAt,desc",
        "partyId,asc",
        "partyId,desc",
        "status,asc",
        "status,desc",
        "totalAmount,asc",
        "totalAmount,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zOrderListResponse = zPageResponseOrderListDto;

export const zOrderCreateBody = zOrderCreateDto;

/**
 * Created
 */
export const zOrderCreateResponse = zOrderDetailDto;

export const zOrderSubmitPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zOrderSubmitResponse = zOrderDetailDto;

export const zOrderListLineItemsPath = z.object({
  id: z.uuid(),
});

export const zOrderListLineItemsQuery = z.object({
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "createdAt,asc",
        "createdAt,desc",
        "description,asc",
        "description,desc",
        "id,asc",
        "id,desc",
        "orderId,asc",
        "orderId,desc",
        "position,asc",
        "position,desc",
        "productRefId,asc",
        "productRefId,desc",
        "productRefType,asc",
        "productRefType,desc",
        "quantity,asc",
        "quantity,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zOrderListLineItemsResponse = zPageResponseOrderLineItemDto;

export const zOrderAddLineItemBody = zOrderLineItemInput;

export const zOrderAddLineItemPath = z.object({
  id: z.uuid(),
});

/**
 * Created
 */
export const zOrderAddLineItemResponse = zOrderLineItemDto;

export const zOrderFulfillPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zOrderFulfillResponse = zOrderDetailDto;

export const zOrderConfirmPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zOrderConfirmResponse = zOrderDetailDto;

export const zOrderClosePath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zOrderCloseResponse = zOrderDetailDto;

export const zOrderCancelBody = zCancelRequest;

export const zOrderCancelPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zOrderCancelResponse = zOrderDetailDto;

export const zOrderMassConfirmBody = zMassActionRequest;

/**
 * OK
 */
export const zOrderMassConfirmResponse = zMassActionResultDto;

export const zOrderMassCancelBody = zMassActionRequest;

/**
 * OK
 */
export const zOrderMassCancelResponse = zMassActionResultDto;

export const zNotificationMarkReadBody = zMarkReadRequest;

/**
 * OK
 */
export const zNotificationMarkReadResponse = zMarkReadResponse;

/**
 * OK
 */
export const zNotificationMarkAllReadResponse = zMarkReadResponse;

export const zNomenclatureTypeListQuery = z.object({
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "category,asc",
        "category,desc",
        "code,asc",
        "code,desc",
        "id,asc",
        "id,desc",
        "name,asc",
        "name,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zNomenclatureTypeListResponse = zPageResponseNomenclatureTypeDto;

export const zNomenclatureTypeCreateBody = zNomenclatureTypeRequest;

/**
 * Created
 */
export const zNomenclatureTypeCreateResponse = zNomenclatureTypeDto;

export const zNomenclatureListItemsPath = z.object({
  typeCode: z.string(),
});

export const zNomenclatureListItemsQuery = z.object({
  code: z.string().optional(),
  codeContains: z.string().optional(),
  nameContains: z.string().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "code,asc",
        "code,desc",
        "id,asc",
        "id,desc",
        "isActive,asc",
        "isActive,desc",
        "isDefault,asc",
        "isDefault,desc",
        "name,asc",
        "name,desc",
        "order,asc",
        "order,desc",
        "typeCode,asc",
        "typeCode,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zNomenclatureListItemsResponse = zPageResponseNomenclatureItemDto;

export const zNomenclatureCreateItemBody = zTypedItemRequestMapStringObject;

export const zNomenclatureCreateItemPath = z.object({
  typeCode: z.string(),
});

/**
 * Created
 */
export const zNomenclatureCreateItemResponse = zNomenclatureItemDto;

export const zNomenclatureImportItemsBody = z.object({
  file: z.string(),
});

export const zNomenclatureImportItemsPath = z.object({
  typeCode: z.string(),
});

/**
 * OK
 */
export const zNomenclatureImportItemsResponse = zImportResultDto;

export const zJobAdminResumeSchedulePath = z.object({
  identity: z.string(),
});

/**
 * No Content
 */
export const zJobAdminResumeScheduleResponse = z.void();

export const zJobAdminPauseSchedulePath = z.object({
  identity: z.string(),
});

/**
 * No Content
 */
export const zJobAdminPauseScheduleResponse = z.void();

export const zJobAdminFireScheduleNowPath = z.object({
  identity: z.string(),
});

export const zJobAdminRetryExecutionPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zJobAdminRetryExecutionResponse = zDispatchResponse;

export const zJobAdminCancelExecutionPath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zJobAdminCancelExecutionResponse = z.void();

export const zJobAdminManualDispatchBody = zManualDispatchRequest;

/**
 * OK
 */
export const zJobAdminManualDispatchResponse = zDispatchResponse;

export const zGroupListQuery = z.object({
  search: z.string().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "code,asc",
        "code,desc",
        "description,asc",
        "description,desc",
        "id,asc",
        "id,desc",
        "name,asc",
        "name,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zGroupListResponse = zPageResponseGroupListDto;

export const zGroupCreateBody = zGroupCreateDto;

/**
 * Created
 */
export const zGroupCreateResponse = zGroupListDto;

export const zGroupAssignPermissionPath = z.object({
  id: z.uuid(),
  permissionId: z.uuid(),
});

/**
 * No Content
 */
export const zGroupAssignPermissionResponse = z.void();

export const zFileListQuery = z.object({
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "createdAt,asc",
        "createdAt,desc",
        "fileName,asc",
        "fileName,desc",
        "id,asc",
        "id,desc",
        "mediaType,asc",
        "mediaType,desc",
        "sizeBytes,asc",
        "sizeBytes,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zFileListResponse = zPageResponseFileListDto;

export const zFileUploadBody = z.object({
  file: z.string(),
});

/**
 * Created
 */
export const zFileUploadResponse = zFileListDto;

export const zFileLinkBody = zLinkRequest;

export const zFileLinkPath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zFileLinkResponse = z.void();

export const zFileUploadUrlBody = zUploadUrlRequest;

/**
 * OK
 */
export const zFileUploadUrlResponse = zPresignedUrl;

export const zEmailLinkUnlinkBody = zEmailLinkRequest;

export const zEmailLinkUnlinkPath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zEmailLinkUnlinkResponse = z.void();

export const zEmailLinkLinkBody = zEmailLinkRequest;

export const zEmailLinkLinkPath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zEmailLinkLinkResponse = z.void();

export const zEmailAttachmentSaveToFilePath = z.object({
  id: z.uuid(),
  partIndex: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
});

/**
 * Created
 */
export const zEmailAttachmentSaveToFileResponse = zFileRef;

export const zEmailSendBody = zEmailSendRequest;

/**
 * Created
 */
export const zEmailSendResponse = zEmailDetailDto;

export const zPaymentCheckoutTestCheckoutScenarioBody =
  zCheckoutScenarioRequest;

/**
 * OK
 */
export const zPaymentCheckoutTestCheckoutScenarioResponse =
  zCheckoutScenarioResponse;

export const zNotificationTestTriggerViberSendBody = zViberSendRequest;

/**
 * OK
 */
export const zNotificationTestTriggerViberSendResponse = zSendResponse;

export const zNotificationTestTriggerUserSignedUpBody = zUserSignedUpRequest;

/**
 * Accepted
 */
export const zNotificationTestTriggerUserSignedUpResponse = zTriggerResponse;

export const zNotificationTestTriggerSmsSendBody = zSmsSendRequest;

/**
 * OK
 */
export const zNotificationTestTriggerSmsSendResponse = zSendResponse;

export const zNotificationTestTriggerReportPublishedBody =
  zReportPublishedRequest;

/**
 * Accepted
 */
export const zNotificationTestTriggerReportPublishedResponse = zTriggerResponse;

export const zAuthRefreshBody = zRefreshBody;

/**
 * OK
 */
export const zAuthRefreshResponse = zRefreshResponse;

/**
 * No Content
 */
export const zAuthLogoutResponse = z.void();

/**
 * No Content
 */
export const zAuthLogoutAllResponse = z.void();

export const zAuthLoginBody = zLoginRequest;

/**
 * OK
 */
export const zAuthLoginResponse = zLoginResponse;

export const zBoricaBridgeBridgeQuery = z.object({
  token: z.string(),
});

/**
 * OK
 */
export const zBoricaBridgeBridgeResponse = z.string();

export const zUserPermissionsPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zUserPermissionsResponse = z.array(z.string());

/**
 * OK
 */
export const zTemplateListResponse = z.array(zTemplateSummaryDto);

export const zTemplateDetailPath = z.object({
  code: z.string(),
});

/**
 * OK
 */
export const zTemplateDetailResponse = zTemplateDetailDto;

export const zPaymentOrderDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zPaymentOrderDetailResponse = zPaymentOrder;

export const zNotificationListQuery = z.object({
  typeCode: z.string().optional(),
  dateFrom: z.iso.datetime().optional(),
  dateTo: z.iso.datetime().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z.array(z.string()).optional(),
});

/**
 * OK
 */
export const zNotificationListResponse = zPageResponseNotificationListDto;

export const zNotificationDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zNotificationDetailResponse = zNotificationDetailDto;

/**
 * OK
 */
export const zNotificationUnreadCountResponse = zUnreadCountResponse;

/**
 * OK
 */
export const zNotificationTypeListResponse = z.array(zNotificationTypeDto);

export const zNomenclatureExportItemsPath = z.object({
  typeCode: z.string(),
});

export const zNomenclatureExportItemsQuery = z.object({
  managedAt: z.enum(["PLATFORM", "DOMAIN", "APP", "ENV", "MANUAL"]).optional(),
});

export const zMobileMessageListQuery = z.object({
  direction: z.enum(["OUTBOUND", "INBOUND"]).optional(),
  channel: z
    .enum(["IN_PLATFORM", "WEBSOCKET", "EMAIL", "SMS", "VIBER", "PUSH"])
    .optional(),
  provider: z.string().optional(),
  status: z
    .enum([
      "QUEUED",
      "SENT",
      "DELIVERED",
      "READ",
      "OPENED",
      "BOUNCED",
      "FAILED",
      "EXPIRED",
    ])
    .optional(),
  address: z.string().optional(),
  notificationId: z.uuid().optional(),
  fromCreatedAt: z.iso.datetime().optional(),
  toCreatedAt: z.iso.datetime().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "address,asc",
        "address,desc",
        "channel,asc",
        "channel,desc",
        "createdAt,asc",
        "createdAt,desc",
        "deliveryStatus,asc",
        "deliveryStatus,desc",
        "direction,asc",
        "direction,desc",
        "externalId,asc",
        "externalId,desc",
        "id,asc",
        "id,desc",
        "notificationId,asc",
        "notificationId,desc",
        "provider,asc",
        "provider,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zMobileMessageListResponse = zPageResponseMobileMessageListDto;

export const zMobileMessageDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zMobileMessageDetailResponse = zMobileMessageDetailDto;

/**
 * OK
 */
export const zJobAdminListSchedulesResponse = z.array(zScheduledJobDto);

export const zJobAdminListExecutionsQuery = z.object({
  status: z.string().optional(),
  jobType: z.string().optional(),
  queue: z.string().optional(),
  createdAfter: z.iso.datetime().optional(),
  createdBefore: z.iso.datetime().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "attempt,asc",
        "attempt,desc",
        "completedAt,asc",
        "completedAt,desc",
        "createdAt,asc",
        "createdAt,desc",
        "createdBy,asc",
        "createdBy,desc",
        "id,asc",
        "id,desc",
        "jobType,asc",
        "jobType,desc",
        "lastError,asc",
        "lastError,desc",
        "maxAttempts,asc",
        "maxAttempts,desc",
        "queue,asc",
        "queue,desc",
        "startedAt,asc",
        "startedAt,desc",
        "status,asc",
        "status,desc",
        "tenantId,asc",
        "tenantId,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zJobAdminListExecutionsResponse = zPageResponseJobExecutionDto;

export const zJobAdminExecutionDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zJobAdminExecutionDetailResponse = zJobExecutionDto;

/**
 * OK
 */
export const zJobAdminListDefinitionsResponse = z.array(zJobDefinitionDto);

export const zFileDeletePath = z.object({
  id: z.uuid(),
});

/**
 * No Content
 */
export const zFileDeleteResponse = z.void();

export const zFileDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zFileDetailResponse = zFileListDto;

export const zFileDownloadPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zFileDownloadResponse = z.string();

export const zFileDownloadUrlPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zFileDownloadUrlResponse = zPresignedUrl;

export const zFileSignedDownloadQuery = z.object({
  path: z.string(),
  expires: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), {
      error: "Invalid value: Expected int64 to be >= -9223372036854775808",
    })
    .max(BigInt("9223372036854775807"), {
      error: "Invalid value: Expected int64 to be <= 9223372036854775807",
    }),
  sig: z.string(),
});

/**
 * OK
 */
export const zFileSignedDownloadResponse = z.string();

export const zEmailListQuery = z.object({
  direction: z.string().optional(),
  search: z.string().optional(),
  deliveryStatus: z
    .enum([
      "QUEUED",
      "SENT",
      "DELIVERED",
      "OPENED",
      "CLICKED",
      "BOUNCED",
      "COMPLAINED",
      "FAILED",
    ])
    .optional(),
  objectType: z.string().optional(),
  objectId: z.uuid().optional(),
  dateFrom: z.iso.datetime().optional(),
  dateTo: z.iso.datetime().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "createdAt,asc",
        "createdAt,desc",
        "deliveryStatus,asc",
        "deliveryStatus,desc",
        "direction,asc",
        "direction,desc",
        "fromAddress,asc",
        "fromAddress,desc",
        "id,asc",
        "id,desc",
        "subject,asc",
        "subject,desc",
        "toAddresses,asc",
        "toAddresses,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zEmailListResponse = zPageResponseEmailListDto;

export const zEmailDetailPath = z.object({
  id: z.uuid(),
});

/**
 * OK
 */
export const zEmailDetailResponse = zEmailDetailDto;

export const zEmailAttachmentByIndexPath = z.object({
  id: z.uuid(),
  partIndex: z
    .int()
    .min(-2147483648, {
      error: "Invalid value: Expected int32 to be >= -2147483648",
    })
    .max(2147483647, {
      error: "Invalid value: Expected int32 to be <= 2147483647",
    }),
});

/**
 * OK
 */
export const zEmailAttachmentByIndexResponse = z.string();

export const zEmailAttachmentByContentIdPath = z.object({
  id: z.uuid(),
  contentId: z.string(),
});

/**
 * OK
 */
export const zEmailAttachmentByContentIdResponse = z.string();

export const zEmailOutboxQuery = z.object({
  direction: z.string().optional(),
  search: z.string().optional(),
  deliveryStatus: z
    .enum([
      "QUEUED",
      "SENT",
      "DELIVERED",
      "OPENED",
      "CLICKED",
      "BOUNCED",
      "COMPLAINED",
      "FAILED",
    ])
    .optional(),
  objectType: z.string().optional(),
  objectId: z.uuid().optional(),
  dateFrom: z.iso.datetime().optional(),
  dateTo: z.iso.datetime().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "createdAt,asc",
        "createdAt,desc",
        "deliveryStatus,asc",
        "deliveryStatus,desc",
        "direction,asc",
        "direction,desc",
        "fromAddress,asc",
        "fromAddress,desc",
        "id,asc",
        "id,desc",
        "subject,asc",
        "subject,desc",
        "toAddresses,asc",
        "toAddresses,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zEmailOutboxResponse = zPageResponseEmailListDto;

export const zEmailInboxQuery = z.object({
  direction: z.string().optional(),
  search: z.string().optional(),
  deliveryStatus: z
    .enum([
      "QUEUED",
      "SENT",
      "DELIVERED",
      "OPENED",
      "CLICKED",
      "BOUNCED",
      "COMPLAINED",
      "FAILED",
    ])
    .optional(),
  objectType: z.string().optional(),
  objectId: z.uuid().optional(),
  dateFrom: z.iso.datetime().optional(),
  dateTo: z.iso.datetime().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "createdAt,asc",
        "createdAt,desc",
        "deliveryStatus,asc",
        "deliveryStatus,desc",
        "direction,asc",
        "direction,desc",
        "fromAddress,asc",
        "fromAddress,desc",
        "id,asc",
        "id,desc",
        "subject,asc",
        "subject,desc",
        "toAddresses,asc",
        "toAddresses,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zEmailInboxResponse = zPageResponseEmailListDto;

export const zAuditEntriesQuery = z.object({
  objectType: z.string().optional(),
  objectId: z.uuid().optional(),
  action: z.string().optional(),
  actorId: zUserRef.optional(),
  dateFrom: z.iso.datetime().optional(),
  dateTo: z.iso.datetime().optional(),
  field: z.string().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "action,asc",
        "action,desc",
        "actorId,asc",
        "actorId,desc",
        "createdAt,asc",
        "createdAt,desc",
        "id,asc",
        "id,desc",
        "objectId,asc",
        "objectId,desc",
        "objectType,asc",
        "objectType,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zAuditEntriesResponse = zPageResponseAuditEntryDto;

/**
 * OK
 */
export const zAuditConfigResponse = z.array(zAuditObjectConfig);

export const zAuditAccessLogQuery = z.object({
  objectType: z.string().optional(),
  objectId: z.uuid().optional(),
  actorId: zUserRef.optional(),
  dateFrom: z.iso.datetime().optional(),
  dateTo: z.iso.datetime().optional(),
  page: z.int().gte(0).optional().default(0),
  size: z.int().gte(1).optional().default(20),
  sort: z
    .array(
      z.enum([
        "action,asc",
        "action,desc",
        "actorId,asc",
        "actorId,desc",
        "createdAt,asc",
        "createdAt,desc",
        "id,asc",
        "id,desc",
        "objectId,asc",
        "objectId,desc",
        "objectType,asc",
        "objectType,desc",
      ]),
    )
    .optional(),
});

/**
 * OK
 */
export const zAuditAccessLogResponse = zPageResponseAccessLogDto;

export const zFileUnlinkPath = z.object({
  id: z.uuid(),
  type: z.string(),
  objectId: z.uuid(),
});

/**
 * No Content
 */
export const zFileUnlinkResponse = z.void();

/**
 * OK
 */
export const zPodiumErrorHandle3Response = zProblemDetailResponse;

/**
 * OK
 */
export const zPodiumErrorHandleResponse = zProblemDetailResponse;

/**
 * OK
 */
export const zPodiumErrorHandle5Response = zProblemDetailResponse;

/**
 * OK
 */
export const zPodiumErrorHandle6Response = zProblemDetailResponse;

/**
 * OK
 */
export const zPodiumErrorHandle4Response = zProblemDetailResponse;

/**
 * OK
 */
export const zPodiumErrorHandle1Response = zProblemDetailResponse;

/**
 * OK
 */
export const zPodiumErrorHandle2Response = zProblemDetailResponse;
